import { FuseRouteConfigType } from "@fuse/utils/FuseUtils";
import SignUpPage from "./SignUpPage";
import authRoles from "../../auth/authRoles";
import i18next from "i18next";
import en from "./i18n/en";
import bg from "./i18n/bg";

i18next.addResourceBundle("en", "signUpPage", en);
i18next.addResourceBundle("bg", "signUpPage", bg);

const SignUpConfig: FuseRouteConfigType = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "sign-up",
      element: <SignUpPage />,
    },
  ],
};

export default SignUpConfig;
